import { CalendarDay, ContributionLevel } from '../src/github/types';
import { GraphData } from '../src/graph/render';

/** Deterministic pseudo-random data so the editor is usable before a username is entered. */
export const sampleData = (): GraphData => {
    let seed = 42;
    const random = () => {
        seed = (seed * 1664525 + 1013904223) % 4294967296;
        return seed / 4294967296;
    };

    const today = new Date();
    const end = Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate());
    const start = end - (52 * 7 + today.getUTCDay()) * 86_400_000;
    const days: CalendarDay[] = [];

    for (let time = start; time <= end; time += 86_400_000) {
        const weekday = new Date(time).getUTCDay();
        const busy = weekday > 0 && weekday < 6 ? 0.8 : 0.35;
        const count = random() < busy ? Math.floor(random() ** 2 * 14) + 1 : 0;
        const level = (
            count === 0 ? 0 : count < 3 ? 1 : count < 6 ? 2 : count < 10 ? 3 : 4
        ) as ContributionLevel;
        days.push({ date: new Date(time).toISOString().slice(0, 10), count, level });
    }

    return {
        username: 'octocat',
        name: 'The Octocat',
        total: days.reduce((sum, day) => sum + day.count, 0),
        days,
    };
};
